import { nanoid } from "nanoid";
import { extractAndValidateJson } from "./message";
import { selectAvatarOnMessage } from "./user";

/**
 * Parses a backend response (which may be plain text, JSON, or a mix of
 * both) and builds the corresponding chat message object(s).
 *
 * This is the single implementation shared by ChatProvider's
 * makeApiCall() and fetchConversations(), which previously duplicated
 * this ~40-line block twice with only cosmetic differences.
 */
export function buildMessagesFromResponse({
  responseText,
  requestText,
  conversation_id,
  session_id,
  createdAt,
  defaultIcon,
  useShojiAvatars,
  busyMessage,
  feedback
}) {
  const { parsedJson, nonJsonPart } = extractAndValidateJson(responseText);
  const messages = [];

  let avatarIcon = defaultIcon;
  if (useShojiAvatars) {
    avatarIcon =
      selectAvatarOnMessage(requestText) ||
      selectAvatarOnMessage(responseText) ||
      defaultIcon;
  }

  if (nonJsonPart && nonJsonPart !== "") {
    if (parsedJson && !parsedJson.comment && !parsedJson.recommendations) {
      messages.push({
        _id: nanoid(),
        text: responseText,
        type: "incoming",
        user: "remote",
        avatar: avatarIcon,
        conversation_id: conversation_id,
        session_id: session_id,
        feedback: feedback,
        createdAt,
      });
    } else {
      messages.push({
        _id: nanoid(),
        text: nonJsonPart,
        type: "incoming",
        user: "remote",
        avatar: avatarIcon,
        conversation_id: conversation_id,
        session_id: session_id,
        feedback: feedback,
        createdAt,
      });
    }
  }

  if (parsedJson && Object.keys(parsedJson).length === 0 && !messages.length) {
    messages.push({
      _id: nanoid(),
      text: busyMessage,
      type: "incoming",
      user: "remote",
      avatar: avatarIcon,
      createdAt,
    });
  } else if (parsedJson) {
    if (parsedJson.comment) {
      messages.push({
        _id: nanoid(),
        text: parsedJson.comment,
        type: "incoming",
        user: "remote",
        avatar: avatarIcon,
        conversation_id: conversation_id,
        feedback: feedback,
        session_id: session_id,
        createdAt,
      });
    }
    if (parsedJson.recommendations) {
      messages.push({
        _id: nanoid(),
        text: parsedJson.comment,
        recommendations: parsedJson.recommendations,
        type: "carousel",
        user: "remote",
        avatar: avatarIcon,
        feedback: feedback,
        conversation_id: conversation_id,
        session_id: session_id,
        createdAt,
      });
    }
  }

  return messages;
}

/** Builds the single fallback "service is busy" message used on hard errors. */
export function buildBusyMessage({ defaultIcon, createdAt, busyMessage }) {
  return {
    _id: nanoid(),
    text: busyMessage,
    type: "incoming",
    user: "remote",
    avatar: defaultIcon,
    createdAt,
  };
}
export function buildSessionTransitionMessage(defaultIcon, createdAt){
  return {
    _id: nanoid(),
    text: "A new Session will start shortly, Please wait",
    type: "incoming",
    user: "remote",
    avatar: defaultIcon,
    createdAt,
  };
}
